import { createContext, useEffect, useState } from "react";

export const PsgTrainingReportContentContext = createContext();

const initialReportContentState = {
  TrainingActivities: "",
};

export const TRAINING_ACTIVITIES = "TrainingActivities";

export const PsgTrainingReportContentContextProvider = ({ children }) => {
  const [content, setContent] = useState(initialReportContentState);

  const setSubTitle = (subTitle, subTitleContent) => {
    setContent((content) => {
      const newContent = {
        ...content,
      };
      newContent[subTitle] = subTitleContent;
      return newContent;
    });
  };

  const getSubTitle = (subTitle) => {
    return content[subTitle];
  };

  useEffect(() => {
    // Get the content from the backend and use setContent to set the same
    console.log(content);
  }, [content]);

  return (
    <PsgTrainingReportContentContext.Provider
      value={{ content, setContent, setSubTitle, getSubTitle }}
    >
      {children}
    </PsgTrainingReportContentContext.Provider>
  );
};
